import { ReactNode } from 'react';
import { Grid } from '@mui/material';

import { Typography } from '@occc/ui-design-system';
import { TextField } from '@occc-app/design-system';

export const OfferNameAndDescriptionConfiguration = ({
  title,
  entityName = 'Offer',
  visibilityHint = 'only visible to you',
  children,
}: {
  entityName?: string;
  title?: string;
  visibilityHint?: string;
  children?: ReactNode;
}) => {
  const fieldColumnSize = children ? 4 : 6;

  return (
    <>
      <Typography variant='subtitle1' paragraph>
        {title || `Set a name for this ${entityName}`}
        <Typography variant='subtitle1' fontWeight={400} component='span' color='textSecondary'>
          &nbsp;({visibilityHint})
        </Typography>
      </Typography>
      <Grid container spacing={3}>
        <Grid item xs={fieldColumnSize}>
          <TextField name='name' label={`${entityName} Name`} />
        </Grid>
        <Grid item xs={fieldColumnSize}>
          <TextField name='description' label={`${entityName} Description`} />
        </Grid>
        {children}
      </Grid>
    </>
  );
};
